import {getEnvironment} from "./get-environment";

export type EnvironmentOptions = {
	hostname: string;
	payments: string;
	secure: boolean;
	port: number;
	protocol: string;
	rejectUnauthorized: boolean; // Only necessary during debug if using a self-signed certificate
	transports: string[];
	timeout?: number;
	forceNew?: boolean;
}
const PROD_OPTIONS: EnvironmentOptions = {
	hostname: 'api.outlawpractice.com',
	payments: 'https://payments.outlawpractice.com/?',
	secure: true,
	port: 443,
	protocol: 'ssl',
	rejectUnauthorized: true, // Only necessary during debug if using a self-signed certificate
	transports: ['websocket'],
};

const BETA_OPTIONS: EnvironmentOptions = {
	hostname: 'api-beta.outlawpractice.com:443',
	payments: 'https://payments.outlawpractice.com/?',
	secure: true,
	port: 443,
	protocol: 'ssl',
	rejectUnauthorized: true, // Only necessary during debug if using a self-signed certificate
	transports: ["websocket"],
};

const DEMO_OPTIONS: EnvironmentOptions = {
	hostname: 'api-demo.outlawpractice.com:443',
	payments: 'https://payments-demo.outlawpractice.com/?',
	secure: true,
	port: 443,
	protocol: 'ssl',
	rejectUnauthorized: true, // Only necessary during debug if using a self-signed certificate
	transports: ["websocket"],
	forceNew: true,
};

const TEST_OPTIONS: EnvironmentOptions = {
	hostname: 'api.outlawpractice.dev:443',
	payments: 'https://payments.outlawpractice.dev/?',
	secure: true,
	port: 443,
	protocol: 'ssl',
	rejectUnauthorized: true, // Only necessary during debug if using a self-signed certificate
	transports: ["websocket"],
	forceNew: true,
};

// Development/test may override their server. Customer tiers use this only with
// an explicit Zitadel cutover and must name their customer Rust API.
const API_HOST: string | undefined = import.meta.env.VITE_API_HOST || undefined;

function customerApiHost(): string {
	if (!API_HOST || /[/?#@\s]/.test(API_HOST)) {
		throw new Error('Customer Zitadel requires VITE_API_HOST as a hostname with optional port');
	}
	new URL(`https://${API_HOST}`); // Validate host/port syntax before any request.
	return API_HOST;
}

// If development (note that in development, the server is proxied on port 80 and the client is on port 443)
const DEV_OPTIONS: EnvironmentOptions = {
	hostname: API_HOST || 'localhost:8000', //`api-dev.outlawpractice.com:443`,
	payments: 'https://localhost:4000/?',
	secure: true,
	protocol: 'ssl',
	port: 443,
	rejectUnauthorized: false,
	timeout: 5000,
	transports: ["websocket"],
	forceNew: false,
};

let SOCKET_OPTIONS: EnvironmentOptions;

switch (getEnvironment()) {
	case 'P':
		SOCKET_OPTIONS = import.meta.env.VITE_IDP_PROVIDER === 'zitadel'
			? {...PROD_OPTIONS, hostname: customerApiHost()} : PROD_OPTIONS;
		break;
	case 'B':
		SOCKET_OPTIONS = import.meta.env.VITE_IDP_PROVIDER === 'zitadel'
			? {...BETA_OPTIONS, hostname: customerApiHost()} : BETA_OPTIONS;
		break;
	case 'T':
		SOCKET_OPTIONS = API_HOST ? {...TEST_OPTIONS, hostname: API_HOST} : TEST_OPTIONS;
		break;
	case 'DM':
		SOCKET_OPTIONS = DEMO_OPTIONS;
		break;
	case 'D':
		SOCKET_OPTIONS = DEV_OPTIONS;
		break;
	default:
		console.warn('Unknown environment:', getEnvironment());
		SOCKET_OPTIONS = DEV_OPTIONS;
}

export default SOCKET_OPTIONS;
